<script setup lang="ts">
import Button from 'primevue/button';

import { useLogout } from '../composables/useLogout';

const { logout, isPending } = useLogout();
</script>

<template>
  <Button
    class="w-full !justify-start"
    severity="secondary"
    text
    :disabled="isPending"
    @click="logout"
  >
    <i class="pi pi-sign-out" />
    Wyloguj
  </Button>
</template>
